<template>
  <div class="order-detail-contain">
    <el-tabs v-model="activeName" @tab-change="handleClick">
      <el-tab-pane label="出运单基本信息" name="first">
        <createlist @getCreateDetails="getCreateDetails"></createlist>
      </el-tab-pane>
      <el-tab-pane label="出运单详情信息" name="second" :disabled="secondAble">
        <createDetails
          ref="detailInfo"
          :createListInfo="createListInfo"
        ></createDetails>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { computed, ref } from "vue";
import createDetails from "./createDetails.vue";
import createlist from "./createList.vue";
import { useRoute } from "vue-router";
export default {
  name: "createShippingPlan",
  components: {
    createDetails,
    createlist,
  },
  setup() {
    const is_ship_list_id = ref("");
    const detailInfo = ref(null);
    const route = ref(useRoute());
    const secondAble = computed(() => {
      let flag = route.value.query.arrData[0] == "udt" || is_ship_list_id.value;
      return !flag;
    });
    const createListInfo = ref(null);
    const activeName = ref("first");
    const handleClick = (TabPanelName) => {
      if (TabPanelName == "second") {
        detailInfo.value.getShippingDetails();
      }
    };
    const getCreateDetails = (val) => {
      const obj = detailInfo.value;
      is_ship_list_id.value = val.ship_id;
      obj.ship_id = val.ship_id;
      obj.ship_no = val.ship_no;
      activeName.value = "second";
      obj.getShippingDetails();
    };
    return {
      activeName,
      handleClick,
      getCreateDetails,
      createListInfo,
      secondAble,
      detailInfo,
    };
  },
};
</script>
<style scoped>
.order-detail-contain {
  padding: 20px 0;
}
</style>
